import { c as _c } from "react/compiler-runtime";
interface ArcadeEmbedProps {
  readonly arcadeUrl: string;
  readonly title?: string;
}
export function ArcadeEmbed(t0) {
  const $ = _c(5);
  const {
    arcadeUrl,
    title: t1
  } = t0;
  const title = t1 === undefined ? "Arcade demo" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      aspectRatio: "16 / 9"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      colorScheme: "light"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== arcadeUrl || $[3] !== title) {
    t4 = <div className="relative w-full overflow-hidden" style={t2}><iframe src={arcadeUrl} title={title} frameBorder="0" loading="lazy" allowFullScreen={true} allow="clipboard-write" className="block h-full w-full" style={t3} /></div>;
    $[2] = arcadeUrl;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}